"use client";
import { Button, Grid, Typography } from "@mui/material";
import FormTextFieldSimple from "../formulari/FormTextFieldSimple";
import { pxToVw } from "@/utils/pxToVw";
import { useState } from "react";
import { getTextWithContext, useText, useTexts } from "@/context/TextContext";
import { useRouter } from "next/navigation";
import { registerStartSchema } from "@/lib/schemas/login";
import z from "zod";
import { MOBILE_BASE } from "@/theme/theme";

export default function RegisterForm() {
  const [form, setForm] = useState({ email: "" });
  const [errors, setErrors] = useState({} as any);

  const router = useRouter();
  const context = useTexts();

  const validateField = (fieldName: keyof typeof form) => {
    const data = {
      [fieldName]: form[fieldName] || undefined,
    };
    const result = registerStartSchema.partial().safeParse(data);
    setErrors((prev: any) => ({
      ...prev,
      [fieldName]: result.success
        ? undefined
        : (z.treeifyError(result.error).properties as any)?.[fieldName],
    }));
  };

  const handleChange = (value: any, fieldName: keyof typeof form) => {
    setForm((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const result = registerStartSchema.safeParse(form);
    if (!result.success) {
      setErrors(z.treeifyError(result.error).properties as any);
      return;
    }

    sessionStorage.setItem("register", JSON.stringify(form));
    const locale = context.locale;

    router.push((locale !== "es-es" ? `/${locale}` : "") + "/register");
  };

  return (
    <Grid
      size={{ xs: 12, md: 6 }}
      bgcolor={{ xs: "#F6F5F5", md: "transparent" }}
      px={{ xs: pxToVw(16, MOBILE_BASE), md: 0 }}
      py={{ xs: pxToVw(22, MOBILE_BASE), md: 0 }}
    >
      <Typography
        variant="body3"
        color="marron"
        mb={{ xs: pxToVw(18, MOBILE_BASE), md: pxToVw(18) }}
        component={"p"}
        fontSize={{
          xs: pxToVw(25, MOBILE_BASE),
          md: pxToVw(24, undefined, 32),
        }}
      >
        {useText("register.form.title")}
      </Typography>
      <Typography
        variant="body5"
        color="marron"
        mb={{ xs: pxToVw(37, MOBILE_BASE), md: pxToVw(47) }}
      >
        {useText("register.form.subtitle")}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormTextFieldSimple
          name="email"
          startAdornmentText={useText("login.form.emailLabel")}
          autoComplete="none"
          value={form.email}
          error={!!errors.email}
          helperText={
            errors.email
              ? errors.email.errors[1]
                ? getTextWithContext(errors.email.errors[1], context)
                : getTextWithContext(errors.email.errors[0], context)
              : ""
          }
          onBlur={(e) => validateField("email")}
          onChange={(e) => handleChange(e.target.value, "email")}
        />
        <Grid container mt={{ xs: pxToVw(35, MOBILE_BASE), md: pxToVw(37) }}>
          <Button
            variant="botonMarron"
            id="button-login-register"
            type="submit"
          >
            {useText("login.form.registerButton")}
          </Button>
        </Grid>
      </form>
    </Grid>
  );
}
